module.exports = {
    title: "Programme",
    crud: {
        create: "Create Programme",
        edit: "Edit Programme",
        view: "View Programme",
    },
    table: {
        name: "Name",
        isActive: 'Active',
    },
    form: {
        name: "Name",
        isActive: 'Active',
    },
    validation: {
        required: {
            name: 'Name is required',
        },
        minLength: {
            name: 'Name must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}